module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgMTkuNTAwNFYyNC41MDA0SDVMMTkuNzQ2NyA5Ljc1Mzc0TDE0Ljc0NjcgNC43NTM3NEwwIDE5LjUwMDRaTTIzLjYxMzMgNS44ODcwN0MyNC4xMzMzIDUuMzY3MDcgMjQuMTMzMyA0LjUyNzA3IDIzLjYxMzMgNC4wMDcwN0wyMC40OTMzIDAuODg3MDdDMTkuOTczMyAwLjM2NzA3IDE5LjEzMzMgMC4zNjcwNyAxOC42MTMzIDAuODg3MDdMMTYuMTczMyAzLjMyNzA3TDIxLjE3MzMgOC4zMjcwN0wyMy42MTMzIDUuODg3MDdaIiBmaWxsPSIjNjY2NTYzIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/type-setting/reject_1.svg
// module id = fxeY
// module chunks = 1